import React, { useEffect, useState } from "react";

const VerifiedInput = ({
  label,
  type = "text",
  placeholder,
  fieldName,
  register,
  errors,
  watch,
  setValue,
  isEmail = false,
  verifyService,
  notValid,
  editMode
}) => {
  const value = watch(fieldName);
  const [isValid, setIsValid] = useState(false);
  const [isShowOtp, setIsShowOtp] = useState(false);
  const [saveOtp, setSaveOtp] = useState("");
  const [isVerified, setIsVerified] = useState(false);
  const [otpError, setOtpError] = useState("");

  // Validate on input
  useEffect(() => {
    if (isEmail) {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      setIsValid(emailPattern.test(value));
    } else {
      setIsValid(value?.length === 10);
    }

    // Reset state on change
    setOtpError("");
    setIsVerified(false);
  }, [value]);

  const handleVerify = async () => {
    const otp = Math.floor(1000 + Math.random() * 9000).toString();
    setSaveOtp(otp);
    const payload = isEmail ? { email: value, otp } : { mobile: value, otp };
    const res = await verifyService(payload);

    if (res.status === 200) {
      setIsShowOtp(true);
      setIsValid(false);
    }
  };



  const handleMatchOtp = (e) => {
    const otp = e.target.value;
    if (otp.length === 4) {
      if (otp === saveOtp) {
        setIsVerified(true);
        setIsShowOtp(false);
        setOtpError("");
      } else {
        setIsVerified(false);
        setOtpError("OTP is incorrect. Please try again.");
      }
    }
  };

  return (
    <div>
      <label>{label}</label>
      <input
        type={type}
        placeholder={placeholder}
        maxLength={!isEmail ? 10 : undefined}
        className={`form-control ${errors[fieldName] ? "is-invalid" : ""}`}
        {...register(fieldName, {
          required: `${label} is required`,
          pattern: isEmail
            ? {
                value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                message: "Invalid email address",
              }
            : {
                value: /^[0-9]{10}$/,
                message: "Invalid phone number",
              },
        })}
      />

      {/* Field error */}
      {errors[fieldName] && (
        <div className="invalid-feedback">{errors[fieldName]?.message}</div>
      )}

      {/* OTP verification result */}
      {isVerified && (
        <p className="text-success mb-0" style={{ fontSize: "12px" }}>
          Verified
        </p>
      )}

      {/* Show verify link only if not verified */}
      { !editMode &&
      (isValid && !isVerified) && notValid && (
        <p
          className="mb-0"
          style={{ fontSize: "12px", color: "#005def", cursor: "pointer" }}
          onClick={handleVerify}
        >
          Verify {isEmail ? "Email Id" : "Mobile Number"}
        </p>
      )
      }

      {/* OTP input */}
      {(notValid && isShowOtp && value?.length > 0)  && (
        <div className="mt-2">
        <label>OTP</label>
          <input
            type="text"
            placeholder="Enter OTP"
            maxLength={4}
            onChange={handleMatchOtp}
            className="form-control mt-2"
          />
          {otpError && (
            <div className="text-danger mt-1" style={{ fontSize: "12px" }}>
              {otpError}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default VerifiedInput;
